
  const COOKIE_NAME = 'announcement_closed';
  const ONE_DAY = 24 * 60 * 60 * 1000;

  function setCookie(name, value, ms) {
    const expires = new Date(Date.now() + ms).toUTCString();
    document.cookie = name + '=' + value + '; expires=' + expires + '; path=/';
  }

  function getCookie(name) {
    return document.cookie
      .split('; ')
      .find(row => row.startsWith(name + '='))
      ?.split('=')[1];
  }

  // 🔒 HIDE BY DEFAULT
  document.body.classList.add('hide-announcement');

  // ✅ SHOW only if cookie does NOT exist
  if (!getCookie(COOKIE_NAME)) {
    document.body.classList.remove('hide-announcement');
    document.body.classList.add('show-announcement');
  }

  // Close button
  const closeBtn = document.querySelector('.announce-close');
  if (closeBtn) {
    closeBtn.addEventListener('click', function () {
      document.body.classList.add('hide-announcement');
      document.body.classList.remove('show-announcement');
      setCookie(COOKIE_NAME, 'true', ONE_DAY);
    });
  }


  document.addEventListener('DOMContentLoaded', () => {
  if (window.innerWidth < 768) return;

  const el = document.querySelector('.custom-announcement-bottom .group-block-content');
  if (!el) return;

  let isDragging = false;
  let startX, startY, startLeft, startTop;

  el.style.position = 'static';
  el.style.cursor = 'grab';

  el.addEventListener('mousedown', (e) => {
    if (e.target !== el) return; // keep scroll + inner clicks

    isDragging = true;
    el.classList.add('is-dragging');
    el.style.cursor = 'grabbing';

    startX = e.clientX;
    startY = e.clientY;

    const rect = el.getBoundingClientRect();
    startLeft = rect.left;
    startTop = rect.top;

    e.preventDefault();
  });

  document.addEventListener('mousemove', (e) => {
    if (!isDragging) return;

    el.style.left = `${startLeft + (e.clientX - startX)}px`;
    el.style.top = `${startTop + (e.clientY - startY)}px`;
  });

  document.addEventListener('mouseup', () => {
    if (!isDragging) return;

    isDragging = false;
    el.classList.remove('is-dragging');
    el.style.cursor = 'grab';
  });
});

window.addEventListener('load', function () {
  const checkNosto = setInterval(() => {
    const nostoDiv = document.querySelector('.nosto-serp-content-native');

    if (nostoDiv) {
      console.log('====================', nostoDiv);
      document.body.classList.add('active-collection');
      clearInterval(checkNosto);
    }
  }, 500);
});

// ----------------------------------------------------------------------  Search Drodown open 

function syncDocumentScrollLock() {
  const hasExpandedPredictiveSearch = Boolean(
    document.querySelector('predictive-search-component.predictive-search--expanded')
  );
  const hasOpenScrollLockDialog = Boolean(
    document.querySelector('dialog[scroll-lock][open], details[scroll-lock][open]')
  );

  if (hasExpandedPredictiveSearch || hasOpenScrollLockDialog) {
    document.documentElement.setAttribute('scroll-lock', '');
    return;
  }

  document.documentElement.removeAttribute('scroll-lock');
}

document.addEventListener('click', (event) => {
  const searchHeader = event.target.closest('.predictive-search-form__header');
  // const headerOverlay = event.target.closest('.header-overlay');
  const headerOverlay = document.querySelector('.header-overlay');
  const predictiveComponent = document.querySelector('predictive-search-component');

  if (!predictiveComponent) return;

  // Open predictive search
  if (searchHeader) {
    predictiveComponent.classList.add('predictive-search--expanded');
    syncDocumentScrollLock();
    return;
  }

  // Close predictive search
  if (headerOverlay) {
    predictiveComponent.classList.remove('predictive-search--expanded');
    syncDocumentScrollLock();
  }
});

document.addEventListener('keydown', (event) => {
  if (event.key !== 'Enter') return;

  const input = event.target.closest(
    '.nosto-autocomplete-wrapper .search-input'
  );

  if (!input) return;

  const predictiveComponent = document.querySelector('predictive-search-component');
  if (!predictiveComponent) return;

  predictiveComponent.classList.remove('predictive-search--expanded');
  syncDocumentScrollLock();
});

function replaceNostoForms() {
  document.querySelectorAll('form.nosto-dropdown-form').forEach(form => {
    const div = document.createElement('div');

    // Copy attributes
    [...form.attributes].forEach(attr => {
      div.setAttribute(attr.name, attr.value);
    });

    // Move children
    while (form.firstChild) {
      div.appendChild(form.firstChild);
    }

    // Replace in DOM
    form.parentNode.replaceChild(div, form);
  });
}

// Run once on load
document.addEventListener('DOMContentLoaded', replaceNostoForms);

// Run again for dynamic injections (Nosto / Shopify)
const observer = new MutationObserver(replaceNostoForms);
observer.observe(document.body, {
  childList: true,
  subtree: true
});


document.addEventListener('click', (event) => {
  const btn = event.target.closest('.ns-act-btn');
  if (!btn) return;

  const searchInput = document.querySelector(
    '.nosto-autocomplete-wrapper .search-input'
  );

  if (!searchInput) return;

  // Focus input
  searchInput.focus();

  // Simulate ENTER key press
  const enterEvent = new KeyboardEvent('keydown', {
    key: 'Enter',
    code: 'Enter',
    keyCode: 13,
    which: 13,
    bubbles: true,
    cancelable: true
  });

  searchInput.dispatchEvent(enterEvent);
});


/* Show / hide reset button while typing */
document.addEventListener('input', (event) => {
  const input = event.target.closest(
    '.nosto-autocomplete-wrapper .search-input'
  );
  if (!input) return;

  const resetBtn = document.querySelector('.predictive-search__reset-button');
  if (!resetBtn) return;

  input.value.trim().length > 1
    ? resetBtn.removeAttribute('hidden')
    : resetBtn.setAttribute('hidden', '');
});

/* Reset button click → clear input */
document.addEventListener('click', (event) => {
  const resetBtn = event.target.closest('.predictive-search__reset-button');
  if (!resetBtn) return;

  const input = document.querySelector(
    '.nosto-autocomplete-wrapper .search-input'
  );
  if (!input) return;

  // Clear input value
  input.value = '';

  // Trigger input event so other listeners update correctly
  input.dispatchEvent(new Event('input', { bubbles: true }));

  // Optional: focus back to input
  input.focus();
});

// ==================================  end search 
document.addEventListener('click', function (e) {
  // e.preventDefault();
  // e.stopImmediatePropagation();
  const customBtn = e.target.closest('.insert-chat-btn');
  if (!customBtn) return;

  e.preventDefault();

  const originalChatBtn = document.querySelector('#inside_liveChatTab');

  if (originalChatBtn) {
    originalChatBtn.click();
  }
});
// --------------- accordion read more less
  if(document.querySelectorAll('.read_more_less a')) document.querySelectorAll('.read_more_less a').forEach(function(read_more_less){
    read_more_less.addEventListener('click', function(e){
      e.preventDefault();
      read_more_less.closest('.details-content').classList.toggle('active');
    });
  });
  // =============================== end accordiom

/*
 * Declarative shadow DOM is only initialized on the initial render of the page.
 * If the component is mounted after the browser finishes the initial render,
 * the shadow root needs to be manually hydrated.
 */
class DeclarativeShadowElement extends HTMLElement {
  connectedCallback() {
    if (!this.shadowRoot) {
      const template = this.querySelector(':scope > template[shadowrootmode="open"]');

      if (!(template instanceof HTMLTemplateElement)) return;

      const shadow = this.attachShadow({ mode: 'open' });
      shadow.append(template.content.cloneNode(true));
    }
  }
}

/**
 * A custom ResizeObserver that only calls the callback when the element is resized.
 * By default the ResizeObserver callback is called when the element is first observed.
 */
class ResizeNotifier extends ResizeObserver {
  #initialized = false;

  /**
   * @param {ResizeObserverCallback} callback
   */
  constructor(callback) {
    super((entries) => {
      if (this.#initialized) return callback(entries, this);
      this.#initialized = true;
    });
  }

  disconnect() {
    this.#initialized = false;
    super.disconnect();
  }
}

/**
 * Event class for overflow minimum items updates
 * @extends {Event}
 */
class OverflowMinimumEvent extends Event {
  /**
   * Creates a new OverflowMinimumEvent
   * @param {boolean} minimumReached - Whether the minimum number of visible items has been reached
   */
  constructor(minimumReached) {
    super('overflowMinimum', { bubbles: true });
    this.detail = {
      minimumReached,
    };
  }
}

class ReflowEvent extends Event {
  /**
   * @param {HTMLElement} lastVisibleElement - The element to move to the last visible position
   */
  constructor(lastVisibleElement) {
    super('reflow', { bubbles: true });
    this.detail = { lastVisibleElement };
  }
}

/**
 * A custom element that wraps a list of items and moves them to an overflow slot when they don't fit.
 * This component is used in the header section, it needs to be render-blocking to avoid layout shifts.
 * @attr {string | null} minimum-items When set, the element enters a 'minimum-reached' state when visible items are at or below this number.
 * @example
 * <overflow-list minimum-items="2">
 *   <!-- list items -->
 * </overflow-list>
 */
class OverflowList extends DeclarativeShadowElement {
  static get observedAttributes() {
    return ['disabled', 'minimum-items'];
  }

  /**
   * @param {string} name
   * @param {string} oldValue
   * @param {string} newValue
   */
  attributeChangedCallback(name, oldValue, newValue) {
    if (name === 'disabled') {
      if (newValue === 'true') {
        this.#reset();
      } else {
        this.#reflowItems();
      }
    }
  }

  connectedCallback() {
    super.connectedCallback();
    const { shadowRoot } = this;

    if (!shadowRoot) throw new Error('Missing shadow root');

    const defaultSlot = shadowRoot.querySelector('slot:not([name])');
    const overflowSlot = shadowRoot.querySelector('slot[name="overflow"]');
    const moreSlot = shadowRoot.querySelector('slot[name="more"]');
    const overflow = shadowRoot.querySelector('[part="overflow"]');
    const list = shadowRoot.querySelector('[part="list"]');
    const placeholder = shadowRoot.querySelector('[part="placeholder"]');

    if (
      !(defaultSlot instanceof HTMLSlotElement) ||
      !(overflowSlot instanceof HTMLSlotElement) ||
      !(moreSlot instanceof HTMLSlotElement) ||
      !(overflow instanceof HTMLElement) ||
      !(list instanceof HTMLUListElement) ||
      !(placeholder instanceof HTMLLIElement)
    ) {
      throw new Error('Invalid element types in <OverflowList />');
    }

    this.#refs = {
      defaultSlot,
      overflowSlot,
      moreSlot,
      overflow,
      list,
      placeholder,
    };

    // Add event listener for reflow requests
    this.addEventListener(
      'reflow',
      /** @param {ReflowEvent} event */ (event) => {
        this.#reflowItems(event.detail.lastVisibleElement);
      }
    );

    if (this.hasAttribute('defer')) {
      const deferredReflow = () => {
        // Remove attribute first to change layout before calculating the actual size
        this.removeAttribute('defer');
        this.#reflowItems();
      };

      const idleCallback = typeof requestIdleCallback === 'function' ? requestIdleCallback : setTimeout;

      idleCallback(() => this.schedule(deferredReflow));
    } else {
      this.#reflowItems();
    }
  }

  disconnectedCallback() {
    this.#resizeObserver.disconnect();
  }

  get schedule() {
    return typeof Theme?.utilities?.scheduler?.schedule === 'function'
      ? Theme.utilities.scheduler.schedule
      : requestAnimationFrame;
  }

  #scheduled = false;

  /**
   * Get the minimum number of items before changing the minimum-reached state
   * @returns {number | null}
   */
  get minimumItems() {
    const value = this.getAttribute('minimum-items');
    return value ? parseInt(value, 10) : null;
  }

  get overflowSlot() {
    const { overflowSlot } = this.#refs;
    return overflowSlot;
  }

  get defaultSlot() {
    const { defaultSlot } = this.#refs;
    return defaultSlot;
  }

  /**
   * @type {{width: number | null, height: number | null}}
   */
  #lastDimensions = {
    width: null,
    height: null,
  };

  /**
   * @type {ResizeObserverCallback & MutationCallback}
   */
  #handleChange = (event) => {
    if (this.#scheduled) return;

    let width = null;
    let height = null;
    let isResize = false;

    for (const [, entry] of event.entries()) {
      if (!(entry instanceof ResizeObserverEntry)) break;
      // There should only be one entry
      isResize = true;
      width = Math.round(entry.contentRect.width);
      height = Math.round(entry.contentRect.height);
    }

    if (isResize) {
      if (!width || !height || (width === this.#lastDimensions.width && height === this.#lastDimensions.height)) {
        // Skip reflow if dimensions are 0 or the same as the last reflow
        return;
      }

      this.#lastDimensions = { width: Math.round(width), height: Math.round(height) };
    }

    this.#scheduled = true;

    this.schedule(() => {
      this.#reflowItems();
      this.#scheduled = false;
    });
  };

  /**
   * Move all items to the default slot.
   */
  #moveItemsToDefaultSlot() {
    const { defaultSlot, overflowSlot } = this.#refs;

    for (const element of overflowSlot.assignedElements()) {
      element.slot = defaultSlot.name;
    }
  }

  /**
   * Reset the list to its initial state and disconnect the observers.
   */
  #reset() {
    const { list } = this.#refs;

    this.#mutationObserver.disconnect();
    this.#resizeObserver.disconnect();
    this.#moveItemsToDefaultSlot();

    list.style.removeProperty('height');
    this.style.setProperty('--overflow-count', '0');
  }

  /**
   * Sets the minimum-reached attribute and dispatches a custom event based on visible elements count
   * @param {Element[]} visibleElements - The currently visible elements
   */
  #updateMinimumReached(visibleElements) {
    if (this.minimumItems !== null) {
      const minimumReached = visibleElements.length < this.minimumItems;

      if (minimumReached) {
        this.setAttribute('minimum-reached', '');
      } else {
        this.removeAttribute('minimum-reached');
      }

      this.dispatchEvent(new OverflowMinimumEvent(minimumReached));
    }
  }

  /**
   * Show all items in the list.
   */
  showAll() {
    const { placeholder } = this.#refs;

    placeholder.style.setProperty('width', '0');
    placeholder.style.setProperty('display', 'none');
    this.setAttribute('disabled', 'true');
  }

  /**
   * Reflow items based on available space within the list.
   * @param {HTMLElement} [lastVisibleElement] Optional element to place in last visible position
   */
  #reflowItems = (lastVisibleElement) => {
    const { defaultSlot, overflowSlot, moreSlot, list, placeholder } = this.#refs;

    this.#resizeObserver.disconnect();
    this.#mutationObserver.disconnect();

    // Avoid layout shifts while reflowing the list
    const { height } = this.firstElementChild?.getBoundingClientRect() ?? {};

    if (height) list.style.height = `${height}px`;
    list.style.setProperty('overflow', 'hidden');

    // Move all elements to the default slot so we can check which ones overflow
    this.#moveItemsToDefaultSlot();

    const elements = defaultSlot.assignedElements();

    // Make sure the "More" item and placeholder are hidden
    moreSlot.hidden = true;
    placeholder.hidden = true;

    // First, check if all the items fit
    const rootRect = list.getBoundingClientRect();

    // Store the initial dimensions for comparison later
    this.#lastDimensions = { width: Math.round(rootRect.width), height: Math.round(rootRect.height) };

    const getVisibleElements = () => elements.filter((el) => el.getBoundingClientRect().top <= rootRect.top);
    let visibleElements = getVisibleElements();

    // If not all items fit or we have a lastVisibleElement, let's calculate with "More" button
    if (visibleElements.length !== elements.length || lastVisibleElement) {
      // Putting the "More" item (and lastVisibleElement, if provided) at the start of the list lets us see which items will fit on the same row
      moreSlot.style.setProperty('order', '-1');
      moreSlot.hidden = false;
      moreSlot.style.setProperty('height', `${height}px`);

      if (lastVisibleElement) {
        lastVisibleElement.style.setProperty('order', '-1');
      }

      // Recalculate the visible elements
      visibleElements = getVisibleElements();

      // Reset the order
      moreSlot.style.removeProperty('order');
      if (lastVisibleElement) {
        lastVisibleElement.style.removeProperty('order');
      }

      // If we have a lastVisibleElement, ensure it's in the last visible position
      if (lastVisibleElement) {
        const visibleIndex = visibleElements.indexOf(lastVisibleElement);
        if (visibleIndex !== -1) {
          // Remove lastVisibleElement from its current position
          visibleElements.splice(visibleIndex, 1);
          // Add it to the end of visible elements
          visibleElements.push(lastVisibleElement);
        }
      }

      moreSlot.style.setProperty('height', 'auto');
    }

    const overflowingElements = elements.filter((element) => !visibleElements.includes(element));
    const [firstOverflowingElement] = overflowingElements;
    const hasOverflow = overflowingElements.length > 0;
    const placeholderWidth = firstOverflowingElement ? firstOverflowingElement.clientWidth : 0;

    // Move the elements to the correct slot
    for (const element of elements) {
      element.slot = overflowingElements.includes(element) ? overflowSlot.name : defaultSlot.name;
    }

    // If there are overflowing elements
    // Show more button and placeholder if needed
    moreSlot.hidden = !hasOverflow;

    if (hasOverflow) {
      // Set the width and height of the placeholder so the list can grow if there is space
      placeholder.style.width = `${placeholderWidth}px`;
      placeholder.hidden = false;
    }

    list.style.setProperty('counter-reset', `overflow-count ${overflowingElements.length}`);
    this.style.setProperty('--overflow-count', `${overflowingElements.length}`);
    list.style.removeProperty('overflow');

    // Check if the minimum-reached state should be updated
    hasOverflow && this.#updateMinimumReached(visibleElements);

    // Observe the list for changes in size
    this.#resizeObserver.observe(this);
    this.#mutationObserver.observe(this, { childList: true });
  };

  /**
   * @type {{
   *   defaultSlot: HTMLSlotElement;
   *   overflowSlot: HTMLSlotElement;
   *   moreSlot: HTMLSlotElement;
   *   overflow: HTMLElement;
   *   list: HTMLUListElement;
   *   placeholder: HTMLLIElement;
   * }}
   */
  #refs;

  /**
   * @type {ResizeObserver}
   */
  #resizeObserver = new ResizeNotifier(this.#handleChange);

  /**
   * @type {MutationObserver}
   */
  #mutationObserver = new MutationObserver(this.#handleChange);
}

if (!customElements.get('overflow-list')) {
  customElements.define('overflow-list', OverflowList);
}

// Function to calculate total height of header group children
function calculateHeaderGroupHeight(
  header = document.querySelector('#header-component'),
  headerGroup = document.querySelector('#header-group')
) {
  if (!headerGroup) return 0;

  let totalHeight = 0;
  const children = headerGroup.children;
  for (let i = 0; i < children.length; i++) {
    const element = children[i];
    if (element === header || !(element instanceof HTMLElement)) continue;
    totalHeight += element.offsetHeight;
  }
  return totalHeight;
}

/**
 * Initialize and maintain header height CSS variables.
 * This is critical for preventing layout shifts during page load.
 * There is a `ResizeObserver` and `MutationObserver` that kicks in post hydration in header.js
 * Note: header-group uses display: contents, so we must observe all children.
 */
(() => {
  const header = document.querySelector('header-component');

  // Early exit if no header - nothing to do
  if (!(header instanceof HTMLElement)) return;

  // Calculate initial height(s
  const headerHeight = header.offsetHeight;
  const headerGroupHeight = calculateHeaderGroupHeight(header);

  document.body.style.setProperty('--header-height', `${headerHeight}px`);
  document.body.style.setProperty('--header-group-height', `${headerGroupHeight}px`);
})();
